// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonScrollTop_root__P-rvL"};